// extracted by mini-css-extract-plugin
module.exports = {"textArea":"TextArea_textArea__15jrN","text":"TextArea_text__1RcPW"};